export default __webpack_public_path__ + "static/media/download.da2e6f42.svg";